import axios from 'axios';

export const handleReturnToPayroll = (payrollName, redirectUrl) => {
  return async dispatch => {
    if (
      window.confirm(
        `Do you want to leave this site and go back to ${payrollName}? Changes that you made on this page may not be saved.`
      )
    ) {
      resetSession();
      window.location.href = appendIncompleteFlagToRedirectUrl(redirectUrl);
    }
  };
};

const appendIncompleteFlagToRedirectUrl = originalUrl => {
  const url = new URL(originalUrl);
  const { origin, pathname, search, hash } = url;
  let params = new URLSearchParams(search);
  params.append('completed', false);
  return `${origin}${pathname}?${params}${hash}`;
};

export const resetSession = () => {
  window.localStorage.removeItem('access_token');
  window.localStorage.removeItem('expires_at');
  window.localStorage.removeItem('api_hostname');

  // reset axios auth header
  delete axios.defaults.headers.common['Authorization'];
};
